import Icon from '@/common/components/Icon';
import { TitleRow } from '../LeadOrders.styles';

export const getHeaders = (onAdd) => [
	[
		<th colSpan={7}>
			<TitleRow>
				Lead orders
				<Icon name='plus' size={20} color='#fff' onClick={() => onAdd()} />
			</TitleRow>
		</th>,
	],
	[
		<th rowSpan={2}>Queue</th>,
		<th rowSpan={2}>Ordered</th>,
		<th colSpan={2}>Algorithm yesterday</th>,
		<th rowSpan={2}>Delivered yesterday</th>,
		<th rowSpan={2}>Delivered avg 3 days</th>,
		<th rowSpan={2}></th>,
	],
	[<th>Current Friday</th>, <th>Next Friday</th>],
];
